var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(1.482 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(-0.482)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33907",
    "data-name": "Path 33907",
    d: "M13.458-8.68c.01.133.01.267.01.4A8.687,8.687,0,0,1,4.721.466,8.688,8.688,0,0,1,0-.914a6.36,6.36,0,0,0,.742.038A6.157,6.157,0,0,0,4.559-2.189,3.08,3.08,0,0,1,1.685-4.321a3.877,3.877,0,0,0,.581.048,3.251,3.251,0,0,0,.809-.1A3.075,3.075,0,0,1,.609-7.4v-.038A3.1,3.1,0,0,0,2-7.043,3.072,3.072,0,0,1,.628-9.6a3.051,3.051,0,0,1,.419-1.551A8.738,8.738,0,0,0,7.386-7.938a3.47,3.47,0,0,1-.076-.7,3.073,3.073,0,0,1,3.074-3.074,3.067,3.067,0,0,1,2.246.971,6.053,6.053,0,0,0,1.951-.742A3.066,3.066,0,0,1,13.23-9.794,6.163,6.163,0,0,0,15-10.27,6.608,6.608,0,0,1,13.458-8.68Z",
    transform: "translate(7.518 22)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCTwitter);
export default __webpack_public_path__ + "static/media/icon_c_twitter.2228acd1f55549991b669ef1688b3825.svg";
export { ForwardRef as ReactComponent };